// extracted by mini-css-extract-plugin
module.exports = {"desktop":"FooterLink_desktop__CR_LU","mobile":"FooterLink_mobile__tt8BV"};